import { render, staticRenderFns } from "./AdminProdHeatmap.vue?vue&type=template&id=7bd1b015&scoped=true&"
import script from "./AdminProdHeatmap.vue?vue&type=script&lang=js&"
export * from "./AdminProdHeatmap.vue?vue&type=script&lang=js&"
import style0 from "./AdminProdHeatmap.vue?vue&type=style&index=0&id=7bd1b015&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd1b015",
  null
  
)

export default component.exports